import type { AttemptRecord } from "../persistence/types.js";

/**
 * Returns the count of consecutive days, ending with the most recent attempt's
 * date, that have at least one attempt. Uses the **UTC** day of `at`.
 * Returns 0 for an empty input or for any malformed timestamp.
 */
export function currentStreakDays(attempts: readonly AttemptRecord[]): number {
  if (attempts.length === 0) return 0;
  const days = new Set<string>();
  let last: number | null = null;
  for (const a of attempts) {
    const t = Date.parse(a.at);
    if (Number.isNaN(t)) continue;
    days.add(toUtcDay(t));
    if (last === null || t > last) last = t;
  }
  if (last === null) return 0;
  let cursor = startOfUtcDay(last);
  let streak = 0;
  while (days.has(toUtcDay(cursor))) {
    streak += 1;
    cursor -= 86_400_000;
  }
  return streak;
}

/** Total distinct UTC days that have at least one attempt. */
export function totalDaysActive(attempts: readonly AttemptRecord[]): number {
  const days = new Set<string>();
  for (const a of attempts) {
    const t = Date.parse(a.at);
    if (!Number.isNaN(t)) days.add(toUtcDay(t));
  }
  return days.size;
}

function toUtcDay(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10);
}

function startOfUtcDay(ms: number): number {
  const d = new Date(ms);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}
